export default "__VITE_ASSET__CEVrOL6O__"